module.exports = __webpack_public_path__ + "img/18.a2a3e747.jpg";